import MembershipManagementChangeRequestSuccess from ".";

export default function MembershipManagementChangeRequestSuccessExamples() {
  return <MembershipManagementChangeRequestSuccess />;
}
